import {
  CardItemTypeService,
  DynamicComponentResolveFunction,
} from '@alfresco/adf-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WkCardItemTypeService {
  constructor(private readonly cardItemTypeService: CardItemTypeService) {}

  public setComponentTypeResolver(
    type: string,
    resolver: DynamicComponentResolveFunction,
    overridde = false
  ): void {
    this.cardItemTypeService.setComponentTypeResolver(
      type,
      resolver,
      overridde
    );
  }
}
